(() => {
  const initialise = (root) => {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const tabs = [...root.querySelectorAll('[data-blog-tab]')];
    const panels = [...root.querySelectorAll('[data-blog-panel]')];
    const previous = root.querySelector('[data-blog-previous]');
    const next = root.querySelector('[data-blog-next]');
    const showAll = root.querySelector('[data-blog-all]');
    let active = root.querySelector('[data-blog-panel]:not([hidden])');
    const track = () => active?.querySelector('[data-blog-track]');
    const syncControls = () => {
      const list = track();
      if (!list) return;
      previous.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
    };
    tabs.forEach(tab => tab.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const panel = panels.find(item => item.dataset.blogPanel === tab.dataset.blogTab);
      if (!panel) return;
      event.preventDefault();
      tabs.forEach(item => item.removeAttribute('aria-current'));
      tab.setAttribute('aria-current', 'true');
      panels.forEach(item => { item.hidden = item !== panel; });
      active = panel;
      showAll.href = tab.href;
      showAll.setAttribute('aria-label', showAll.dataset.label + ' — ' + tab.textContent.trim());
      track().scrollLeft = 0;
      syncControls();
    }));
    const move = direction => {
      const list = track();
      const card = list?.querySelector('.rxs-blog-card');
      if (!card) return;
      const amount = card.getBoundingClientRect().width + 20;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollBy({left: direction * amount, behavior: reduced ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    panels.forEach(panel => panel.querySelector('[data-blog-track]').addEventListener('scroll', syncControls, {passive:true}));
    new ResizeObserver(syncControls).observe(root);
    syncControls();
  };
  const start = () => document.querySelectorAll('[data-rxs-blog]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
